<template>
  <div class="check-user body">
    <v-sheet class="pa-3" color="transparent">
      <v-alert prominent type="warning">
        <v-row align="center">
          <v-col class="grow"> 您还没有登录 </v-col>
          <v-col class="shrink">
            <v-btn outlined block @click="fnGoSign()"> 去登录 </v-btn>
          </v-col>
        </v-row>
      </v-alert>
    </v-sheet>
  </div>
</template>

<script>
export default {
  name: "CheckUser",
  props: {
    currentNav: { type: Number, required: false, default: 0 },
  },
  data: () => ({}),
  created() {},
  mounted() {},
  methods: {
    fnGoSign() {
      localStorage.tempURL = location.href;
      this.$router.push("/mine");
    },
  },
};
</script>
